import request from '@/utils/request';
import Resource from '@/api/resource';

const scoopResource = new Resource('scoops');

export default {
  list(params) {
    return scoopResource.list(params);
  },
  get(id) {
    return scoopResource.get(id);
  },
  store(data) {
    return scoopResource.store(data);
  },
  update(id, data) {
    return scoopResource.update(id, data);
  },
  destroy(id) {
    return scoopResource.destroy(id);
  },
  toggleStatus(id, type) {
    return scoopResource.get(`toogle_${type}/${id}`);
  },
  affecterUnitesProduction(id, unitesProduction) {
    return request({
      url: '/scoops/' + id + '/affecter_unites_production',
      method: 'post',
      data: { unite_production_ids: unitesProduction },
    });
  },
  getUnitesProduction(id) {
    return scoopResource.sublist(`/${id}/unites_production`, {});
  },
  sublist(suburl, params) {
    // helper for indexactive/indexdesactive/indexinvisible
    return scoopResource.sublist(`/${suburl}`, params);
  },
};

